<template>
  <div class="product-upload">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>ファイルアップロード</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="アップロード済み:" label-cols-md="3" label-align-md="right">
            <b-table
              thead-class="uploads-thead"
              striped
              hover
              stacked="md"
              head-variant="light"
              primary-key="id"
              :items="state.list"
              :fields="fields"
            >
              <template #cell(download)="data">
                <b-link :href="'/uploads/'+data.item.filename" download>
                  ファイル{{ data.index + 1 }}
                </b-link>
              </template>
              <template #cell(actions)="data">
                <b-button @click="onDelete(data.item.id)" variant="danger">削除</b-button>
              </template>
            </b-table>
          </b-form-group>
          <b-form-group label="ファイル:" label-cols-md="3" label-align-md="right">
            <b-form-file
              placeholder="ファイルを選択"
              drop-placeholder="ファイルをここにドロップ"
              browse-text="参照"
              v-model="file"
            />
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">アップロード</b-button>
          <b-button type="reset" variant="outline-primary">クリア</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductUpload',
  data() {
    return {
      fields: [
        'download',
        'actions',
      ],
      file: null,
    };
  },
  computed: {
    ...mapState({ state: 'uploads' }),
  },
  mounted() {
    this.$store.dispatch('uploads/list', this.$route.params.id);
  },
  methods: {
    onDelete(id) {
      this.$utils.confirm('ファイル削除', '削除してよろしいですか？', () => {
        this.$store.dispatch('uploads/delete', {
          productId: this.$route.params.id,
          id: id,
        });
      });
    },
    onSubmit(evt) {
      this.$store.dispatch('uploads/upload', {
        productId: this.$route.params.id,
        file: this.file,
      });
      this.file = null;
    },
    onReset(evt) {
      this.file = null;
    },
  },
};
</script>

<style scoped>
</style>

<style>
.uploads-thead {
  display: none;
}
</style>
